module.exports = __webpack_public_path__ + "img/aftersalesLogo2.4266fc9b.png";